import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WithRender from "@/Pages/Admin/Modules/Admin/Views/accountDashboard.html";
import Userrole from "@/Pages/Admin/Modules/Admin/StoreUserInfo/Userrole";
import { trekService } from "@/Pages/Admin/Modules/ManagePackage/Services/Trekservice";
import { Cookie } from "../../Common/Services/CookieService";
import { flashService } from "@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService";

import { common } from "@/Pages/Admin/Modules/Common/Services/Common";
@WithRender
@Component
export default class AccountDashboard extends Vue {
  protected ui: any = {};
  protected errors: any = {};
  protected errorsMessage: any = {};
  protected isError: boolean = false;
  private activeUser: any = {};
  private AccountList: any = [];
  constructor() {
    super();
    this.activeUser = {};

    this.ui.IsLoading = false;
    this.ui.PostLoading = false;
  }
  public created() {
    this.activeUser = common.CurrentLoggedBusinessUser()
      ? common.CurrentLoggedBusinessUser()
      : "";
    this.getAccountLists();
  }
  public getAccountLists() {
    const data = {
      uuid: this.activeUser.uid,
    };
    this.ui.IsLoading = true;
    trekService
      .addAccountList(data)
      .then((res: any) => {
        // console.log("DATA", res.data.data);
        if (res.data.data.length === 1) {
          this.selectedAccount(res.data.data[0]);
        } else {
          this.AccountList = res.data.data;
          Userrole.GetPackageTitle(res.data.data);
          this.selectedAccount(res.data.data);
        }
        this.ui.IsLoading = false;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.errorsMessage).then((res: any) => {
          this.isError = true;
          this.errorsMessage = res;
        });
      });
  }
  public selectedAccount(account: any) {
    
    let userId = account.user_id;
    let uuId = account.uuid;
    let data = {
      uuid: uuId,
      user_id: userId
    };
    this.ui.PostLoading = true;
    trekService
      .addSelection(data)
      .then((res: any) => {
        // console.log("Data on Selection", res.data.data);
        Userrole.GetPackageTitle(res.data.data);
        // console.log("Details for token", res.data.data.token);

        // this.AccountList = res.data.data;
        // this.$router.push({ name: "business-dashboard" });
        Cookie.set("business_auth_token", res.data.data.token);
        if (Cookie.check("business_auth_token")) {
          // console.log("",);
          this.$router.push({ name: "business-dashboard" });
        } else {
          this.$router.push({ name: "account-selection-dashboard" });
          window.localStorage.clear();
        }
        this.ui.PostLoading = false;
      })
      .catch((error: any) => {
        common.sdCatchErr(error, this.errorsMessage).then((res: any) => {
          this.isError = true;
          this.errorsMessage = res;
        });
      });
  }
}
